import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 750E27F3-36FF-423A-8AAD-F2FE833D9028
 * name alpha-p
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-p.svg
 * tags
 * - Automotive 
 * - Alpha / Numeric 
 */
export const AlphaPIcon = createSvgIcon(<><path d="M9,7V17H11V13H13A2,2 0 0,0 15,11V9A2,2 0 0,0 13,7H9M11,9H13V11H11V9Z" /></>, 'AlphaPIcon');
export default AlphaPIcon